import React from 'react';
import { RealizedGainLossDetailsSkeleton } from './RealizedGainLossDetailsSkeleton';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  title: string;
  onRetry?(): void;
}

export const RealizedGainLossDetailsError = ({ title, onRetry }: Props) => {
  return (
    <RealizedGainLossDetailsSkeleton title={title}>
      <Box p="56" bg="bg">
        <ErrorState onAction={onRetry} />
      </Box>
    </RealizedGainLossDetailsSkeleton>
  );
};
